import styled from 'styled-components';
import { Box, Flex, Text, FlexProps } from '@mantine/core';
import { PropsWithChildren } from 'react';

interface Props {
	icon?: React.ReactNode;
	headerActions?: React.ReactNode;
	title: string | React.ReactNode;
	style?: React.CSSProperties;
}

export const ContainerWithHeader = ({
	icon,
	title,
	children,
	headerActions,
	style,
}: PropsWithChildren<Props>) => {
	return (
		<StyledContainer direction="column" style={style}>
			<Flex
				gap="0.5rem"
				align="center"
				bg="gray.0"
				sx={(theme) => ({
					border: `1px solid ${theme.colors.gray[2]}`,
					borderTopRightRadius: '0.5rem',
					borderTopLeftRadius: '0.5rem',
				})}
			>
				{icon}
				{typeof title === 'string' ? (
					<Text data-testid={`header-title-${title}`} fw={600}>
						{title}
					</Text>
				) : (
					title
				)}
				{headerActions && (
					<Flex style={{ flex: 1 }} justify="end">
						{headerActions}
					</Flex>
				)}
			</Flex>
			<Box
				bg="white.0"
				sx={(theme) => ({
					border: `1px solid ${theme.colors.gray[2]}`,
					borderTop: 'none',
					borderBottomRightRadius: '0.5rem',
					borderBottomLeftRadius: '0.5rem',
					overflow: 'auto',
					boxSizing: 'content-box',
				})}
			>
				{children}
			</Box>
		</StyledContainer>
	);
};

const StyledContainer = styled(Flex)<FlexProps>`
	width: 100%;
	background-color: white;

	& > * {
		padding: 1rem;
	}
`;
